<template>
  <div class="faux-paper">
    <slot></slot>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  components: {},
  props: [],
};
</script>
<style scoped>
.faux-paper {
  background-color: var(--backgroundColor);
  filter: drop-shadow(0 0 2px var(--secondaryColor));
  border-radius: 3px;
}
</style>
